import axios from 'axios';
import { ApiResponseType, NetworkType } from '../../types/types';
import {
  AddAddressForUserRequest,
  AddAddressForUserResponse,
  BuyLicenceResponse,
  Confirm2StepVerificationActivationResponse,
  Enable2StepVerificationResponse,
  GetAddressesForUserResponse,
  // Get2StepVerificationStatusResponse,
  GetUserNotificationSettingsResponse,
  GetUserSecuritySettingsResponse,
  GetUserSettingsAccountDataResponse,
  GetUserSettingsResponse,
  TeamCompletionSortingEnum,
  // TeamCompletionSortingEnum,
  UpdateUserSignIn2FAEnabledResponse,
  UploadProfileImageResponse
} from './settings.types';

export const getSettingsAccountAsync = async (): Promise<
  ApiResponseType<GetUserSettingsAccountDataResponse>
> => {
  const { data } = await axios.get<
    ApiResponseType<GetUserSettingsAccountDataResponse>
  >(`/user/settings/account`);
  return data;
};

export const getSettingsNotificationsAsync = async (): Promise<
  ApiResponseType<GetUserNotificationSettingsResponse>
> => {
  const { data } = await axios.get<
    ApiResponseType<GetUserNotificationSettingsResponse>
  >('/user/settings/notifications');
  return data;
};

export const setNotificationAsync = async (
  notifications: any
): Promise<ApiResponseType<GetUserSettingsAccountDataResponse>> => {
  const { data } = await axios.put<
    ApiResponseType<GetUserSettingsAccountDataResponse>
  >(`/user/settings/notifications`, notifications);
  return data;
};

export const updateUsernameAsync = async (
  username: string
): Promise<ApiResponseType<GetUserSettingsAccountDataResponse>> => {
  const { data } = await axios.put<
    ApiResponseType<GetUserSettingsAccountDataResponse>
  >('/user/settings/account/username', { username });
  return data;
};

export const changePasswordAsync = async (
  oldPassword: string,
  newPassword: string
): Promise<ApiResponseType<any>> => {
  const { data } = await axios.put<ApiResponseType<any>>(
    '/user/password/change',
    {
      oldPassword,
      newPassword
    }
  );
  return data;
};

export const getTeamSettingsAsync = async (): Promise<
  ApiResponseType<GetUserSettingsResponse>
> => {
  const { data } = await axios.get<ApiResponseType<GetUserSettingsResponse>>(
    '/user/settings'
  );
  return data;
};

export const updateTeamSettingsAsync = async (
  teamCompletionSorting: TeamCompletionSortingEnum
): Promise<ApiResponseType<GetUserSettingsResponse>> => {
  const { data } = await axios.put<ApiResponseType<GetUserSettingsResponse>>(
    '/user/settings',
    { teamCompletionSorting }
  );
  return data;
};

export const getVerificationSecurityAsync = async (): Promise<
  ApiResponseType<GetUserSecuritySettingsResponse>
> => {
  const { data } = await axios.get<
    ApiResponseType<GetUserSecuritySettingsResponse>
  >('/user/settings/security');
  return data;
};

// export const getVerificationStatusAsync = async (): Promise<
//   ApiResponseType<Get2StepVerificationStatusResponse>
// > => {
//   const { data } = await axios.get<
//     ApiResponseType<Get2StepVerificationStatusResponse>
//   >('/user/settings/security/2fa/status');
//   return data;
// };

export const enableVerificationStatusAsync = async (): Promise<
  ApiResponseType<Enable2StepVerificationResponse>
> => {
  const { data } = await axios.post<
    ApiResponseType<Enable2StepVerificationResponse>
  >('/user/settings/security/2fa/enable');
  return data;
};

export const confirmVerificationAsync = async (
  emailCode: string,
  twoFACode: string
): Promise<ApiResponseType<Confirm2StepVerificationActivationResponse>> => {
  const { data } = await axios.put<
    ApiResponseType<Confirm2StepVerificationActivationResponse>
  >('/user/settings/security/2fa/enable/confirm', {
    emailCode,
    twoFACode
  });
  return data;
};

export const disableVerificationStatusAsync = async (
  emailCode: string,
  twoFACode: string
): Promise<ApiResponseType<any>> => {
  const { data } = await axios.post<ApiResponseType<any>>(
    '/user/settings/security/2fa/disable',
    {
      emailCode,
      twoFACode
    }
  );
  return data;
};

export const confirm2FAVerificationAsync = async (
  emailCode: string,
  twoFACode: string,
  signIn2FAEnabled: boolean
): Promise<ApiResponseType<UpdateUserSignIn2FAEnabledResponse>> => {
  const { data } = await axios.put<
    ApiResponseType<UpdateUserSignIn2FAEnabledResponse>
  >('/user/settings/security/signin/2fa', {
    emailCode,
    twoFACode,
    signIn2FAEnabled: signIn2FAEnabled ? false : true
  });
  return data;
};

export const confirm2FAEmailAsync = async (
  emailCode: string
): Promise<ApiResponseType<any>> => {
  const { data } = await axios.put<ApiResponseType<any>>(
    '/user/settings/security/signin/email-verification/enable/confirm',
    {
      emailCode
    }
  );
  return data;
};

//this is not in use currently
export const sendEmailCodeForTwoFaAsync = async (
  type: number
): Promise<ApiResponseType<any>> => {
  const { data } = await axios.put<ApiResponseType<any>>(
    '/user/settings/security/2fa/email/code',
    {
      type
    }
  );
  return data;
};
//this is not in use currently

export const buyVirtualOfficeAsync = async (
  licenceId: number,
  networkType: NetworkType | null,
  currencyType: number
): Promise<ApiResponseType<BuyLicenceResponse>> => {
  const { data } = await axios.post<ApiResponseType<BuyLicenceResponse>>(
    '/virtual-office/licence/buy',
    currencyType === 1 || currencyType === 7
      ? { currencyType, networkType, licenceId }
      : { currencyType, licenceId }
  );
  return data;
};

export const uploadProfileImageAsync = async (
  formData: FormData
): Promise<ApiResponseType<UploadProfileImageResponse>> => {
  const { data } = await axios.post<
    ApiResponseType<UploadProfileImageResponse>
  >(`/user/profile/image`, formData);

  return data;
};

export const addAddressAsync = async ({
  addressLine1,
  addressLine2,
  zipCode,
  country,
  countryCode,
  isPermanent,
  city
}: AddAddressForUserRequest): Promise<
  ApiResponseType<AddAddressForUserResponse>
> => {
  const { data } = await axios.post<ApiResponseType<AddAddressForUserResponse>>(
    `/user/address`,
    {
      addressLine1,
      addressLine2,
      zipCode,
      country,
      countryCode: countryCode ? countryCode : '+386',
      isPermanent,
      city
    }
  );

  return data;
};

export const getAddressAsync = async (): Promise<
  ApiResponseType<GetAddressesForUserResponse>
> => {
  const { data } = await axios.get<
    ApiResponseType<GetAddressesForUserResponse>
  >(`/user/address`);
  return data;
};

export const getLicensesAsync = async (productId?: number) => {
  const { data } = await axios.get(`/products/backoffice-licences`, {
    params: { productId }
  });
  return data;
};
